import {RootState} from "../../../../store";

export const getTwilioChatsActiveTwilioToken = (state: RootState) => state.twilioChatsReducer.activeTwilioToken;
export const getTwilioChatsPersonalToken = (state: RootState) => state.twilioChatsReducer.personalTwilioToken;
export const getTwilioChatsClient = (state: RootState) => state.twilioChatsReducer.client;
export const getTwilioChatsMessages = (state: RootState) => state.twilioChatsReducer.messages;
export const getTwilioChatsPersonalChatsTokens = (state: RootState) => state.twilioChatsReducer.myPrivateChatsToken;
export const getTwilioChatsConversation = (state: RootState) => state.twilioChatsReducer.conversation;

